<div
  class="seller-signup h-screen overflow-y-auto bg-[#BBDEEB] bg-cover bg-no-repeat bg-center"
>
  <div class="container mx-auto flex justify-center px-17.5 pt-12 relative h-full">
    <sham-i-sham-logo-Full class="px-2 absolute top-4 xl:inset-s-17.5 inset-s-12" />
    <div
      class="sm:w-[645px] p-8 rounded-lg bg-white-light space-y-4 absolute top-1/2 -translate-y-1/2"
    >
      <h2
        class="font-semibold text-[32px] text-neutral p-2.5 leading-6 text-center mb-12"
      >
        {{ 'Login to Dashboard' | translate }}
      </h2>
      <section class="space-y-4">
        <!-- <h4 class="text-[#178EB4] font-semibold">Personal Information</h4> -->

        <dx-form
          [formData]="formData()"
          [colCount]="1"
          [labelLocation]="'top'"
          [rtlEnabled]="language.isRTL()"
          (keydown.enter)="onSubmit()"
          (onContentReady)="focusEmail($event)"
        >
          <dxi-item
            dataField="email"
            [label]="{ text: 'Email' | translate }"
            [editorOptions]="{
              mode: 'email',
              valueChangeEvent: 'input',
              placeholder: 'name@example.com',
              validationMessageMode: 'always',
              buttons: [
                {
                  name: 'email',
                  location: 'before',
                  options: {
                    icon: 'email',
                    stylingMode: 'text',
                    focusStateEnabled: false,
                    elementAttr: {
                      class: 'cursor-auto custom-icon-color pointer-events-none',
                    },
                  },
                },
              ],
            }"
            [validationRules]="[
              { type: 'required', message: 'Email is required' | translate },
              { type: 'email', message: 'Email format is invalid' | translate },
            ]"
          />

          <dxi-item
            dataField="password"
            [label]="{ text: 'Password' | translate }"
            [editorOptions]="{
              mode: 'password',
              valueChangeEvent: 'input',
              placeholder: 'Password' | translate,
              validationMessageMode: 'always',
              buttons: [
                {
                  name: 'key',
                  location: 'before',
                  options: {
                    icon: 'key',
                    stylingMode: 'text',
                    focusStateEnabled: false,
                    elementAttr: {
                      class: 'cursor-auto custom-icon-color pointer-events-none',
                    },
                  },
                },
              ],
            }"
            [validationRules]="[
              { type: 'required', message: 'Password is required' | translate },
            ]"
          />

          <dxi-item
            dataField="rememberMe"
            editorType="dxCheckBox"
            [label]="{ visible: false }"
            [editorOptions]="{
              text: 'Remember Me' | translate,
            }"
          />
        </dx-form>
        <div
          *ngIf="submitError()"
          role="alert"
          class="text-red-500 text-sm text-center"
        >
          {{ submitError() }}
        </div>
        <dx-button
          [text]="(loading() ? 'Signing in...' : 'Login') | translate"
          type="default"
          stylingMode="contained"
          [width]="'100%'"
          [height]="44"
          [disabled]="loading()"
          (onClick)="onSubmit()"
        />
      </section>
    </div>
    <div class="page-footer-copy absolute bottom-0 text-center text-[#6D6D6D]">
      {{ 'All rights reserved © Shamsuperstore.com' | translate }}
    </div>
  </div>
</div>
